<template>
  <collapsible-transition :show-transition-on-appear="showTransition">
    <card-panel-list-item
      v-if="featureSwitchesState.UNPUBLISHED_RECOMMENDED_JOBS"
      v-show="isVisible"
      :need-review="isPublished ? needReview : false"
      :clickable="clickable"
      @click="$emit('click')">
      <p slot="title" class="paragraph paragraph-bold">
        <span>{{ title }}</span>
        <b-tag v-if="isPublished && interested" :type="interestedBadge.type" rounded>
          {{ interestedBadge.text }}
        </b-tag>
      </p>
      <list-item-general-info
        slot="left-column"
        :description="description"
        :location="location"
        :clickable="clickable">
      </list-item-general-info>
      <formatted-salary slot="right-column" :salary="salary" />

      <div slot="button-bar" class="button-bar">
        <recommended-jobs-apply-button
          v-if="isPublished"
          :recommended-job-id="recommendedJobId"
          :job-code="jobCode">
        </recommended-jobs-apply-button>
        <recommended-jobs-interested-button
          v-else
          :recommended-job-id="recommendedJobId"
          :interested="interested">
        </recommended-jobs-interested-button>
        <recommended-jobs-dismiss-button
          v-if="isPublished || !interested"
          :recommended-job-id="recommendedJobId">
        </recommended-jobs-dismiss-button>
      </div>
    </card-panel-list-item>

    <card-panel-list-item
      v-else
      v-show="isVisible"
      :need-review="needReview"
      :clickable="clickable"
      @click="$emit('click')">
      <p slot="title" class="paragraph paragraph-bold">{{ title }}</p>
      <list-item-general-info
        slot="left-column"
        :description="description"
        :location="location"
        :clickable="clickable">
      </list-item-general-info>
      <formatted-salary slot="right-column" :salary="salary" />
    </card-panel-list-item>
  </collapsible-transition>
</template>

<script>

import CardPanelListItem from 'top20common/components/card-panel/CardPanelListItem';
import CollapsibleTransition from 'top20common/components/collapsible/CollapsibleTransition';
import {mapGetters} from 'vuex';

import FormattedSalary from '../common/FormattedSalary';
import ListItemGeneralInfo from '../common/ListItemGeneralInfo';
import RecommendedJobsApplyButton from './RecommendedJobsApplyButton';
import RecommendedJobsDismissButton from './RecommendedJobsDismissButton';
import RecommendedJobsInterestedButton from './RecommendedJobsInterestedButton';

export default {
  props: {
    title: String,
    recommendedJobId: String,
    jobCode: String,
    isVisible: Boolean,
    needReview: Boolean,
    description: String,
    location: {type: String, default: ''},
    salary: Number,
    interested: Boolean,
    clickable: {type: Boolean, default: false}
  },
  mounted() {
    this.showTransition = true;
  },
  data() {
    return {
      showTransition: false
    };
  },
  computed: {
    ...mapGetters(['featureSwitchesState', 'recommendedPublishedJobByCodeState']),
    isPublished() {
      return this.recommendedPublishedJobByCodeState[this.jobCode];
    },
    interestedBadge() {
      return {
        text: this.$gettext('Interest'),
        type: 'cgp-red'
      };
    }
  },
  components: {
    CardPanelListItem,
    ListItemGeneralInfo,
    FormattedSalary,
    RecommendedJobsApplyButton,
    RecommendedJobsDismissButton,
    RecommendedJobsInterestedButton,
    CollapsibleTransition
  }
};
</script>

<style lang="scss" scoped>
.row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  .no-wrap {
    white-space: nowrap;
  }
}

/deep/ .fill {
  fill: var(--gray);
}
</style>
